import { ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants } from '@festina/datamart-general-types/datamart/hooks/ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants'

export const useFetchDatamartTenants =
  ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants.useSuspenseQuery
